module.exports = __webpack_public_path__ + "static/img/first.d8d89d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/first.png
// module id = ijcP
// module chunks = 0